import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import Loader from 'components/Loader';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';
import ReactTable from "react-table";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import { caStateOpts, usStateOpts } from '../../utils';

const propTypes = {
    id: PropTypes.string,
    companyId: PropTypes.number,

};

export default class ViewDidtributorProfile extends React.Component {
    constructor(props) {
        super(props);
        this.defaultNewLocation = {
            company_name: '',
            website: '',
            phone: '',
            address: '',
            city: '',
            stateprovince: '',
            postal: '',
            display_location: true,
            geospatial: null,
            latitude: null,
            longitude: null,
            country: '',
            cdata: '',
            showroom: false,
        };

        this.defaultCdataFields = {
            wholesale: true,
            consumer: false,
        };
        this.state = {
            userD: { },
            companyD: { },
            cData: { },
            userLoaded: false,
            compLoaded: false,
            cDataLoaded: false,
            updateFlag: false,
            editingProfile: false,
            isError: false,
            uploadingCertificate: false,
            proCoords: false,
            companyId: null,
            searchLoc: '',
            locations: [],
            newLocation: {...this.defaultNewLocation},
            cdataF: {...this.defaultCdataFields},
            editingLocationId: null,
            savingLocation: false,
            csvUploading: false,
        };
    }


    editProfile = () => {
        this.setState({editingProfile: !this.state.editingProfile});
    };

    componentDidMount() {
        this.getUserData(this.props.id);
        this.getcData(this.props.id);
        this.getCompanyData(this.props.companyId);
        this.getLocations(this.props.companyId);

    }

    componentDidUpdate() {
        if(this.state.updateFlag === true) {
            this.getUserData(this.props.id);
            this.getcData(this.props.id);
            this.getCompanyData(this.props.companyId);
            this.setState({
                updateFlag: false,
                editingProfile: false
            });
        }
    }

    getUserData(id){
        return new Promise((resolve, reject) => {
            request.get(`/api/user/${id}`)
                .then(resp => {
                    this.setState({
                        userD: resp.body.user,
                        userLoaded: true
                    });
                   // console.log('us', resp.body.user);
                    resolve(resp.body);
                });

        });
    };

    getcData(id){
        return new Promise((resolve, reject) => {
            request.get(`/api/user/${id}`)
                .then(resp => {
                    this.setState({
                        cData: resp.body.user.cdata,
                        cDataLoaded: true
                    });
                    resolve(resp.body);
                });
        });
    };

    getCompanyData(compId){
        return new Promise((resolve, reject) => {
            request.get(`/api/company/${compId}`)
                .then(resp => {
                    this.setState({
                        companyD: resp.body.company,
                        compLoaded: true
                    });
                    resolve(resp.body);
                });

        });
    };

    getLocations(compId) {
        request.get(`/api/company/${compId}/locations`)
            .then(resp => {
                // console.log(resp.body);
                this.setState({
                    compLoaded: true,
                    companyId: resp.body.company.id,
                    locations: resp.body.company.company_locations,
                });
            });

    };

    showAlert(e, row, id) {
        e.preventDefault();
        this.setState({
            deleteId: id,
        });

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui-dialog'>
                        <h3>Are you sure you want to delete this location?</h3>
                        <br/>
                        <button
                            className="btn btn-default btn-primary btn-view-users cancel"
                            onClick={onClose}>Cancel</button>
                        <button
                            className="btn btn-default btn-primary btn-view-users delete"
                            onClick={() => {
                                this.handleDeleteLocation();
                                onClose();
                            }}>Confirm Delete</button>
                    </div>
                )
            }
        })
    };


    handleDeleteLocation() {
        request.delete(`/api/company/location/${this.state.deleteId}`)
            .then(resp => {
                let locations = this.state.locations.filter(l => l.id !== this.state.deleteId);
                this.setState({
                    locations,
                    deleteId: null
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    openNewLocationModal = () => {
        document.querySelector('body').classList.add('modal-open');
        this.refs.locationModal.classList.add('in');
    }

    closeNewLocationModal = () => {
        this.refs.locationModal.classList.remove('in');
        document.querySelector('body').classList.remove('modal-open');
        this.setState({
            newLocation: {...this.defaultNewLocation},
            editingLocationId: null,
            savingLocation: false,
            cdataF: {...this.defaultCdataFields},
        });
    }

    saveLocation = async () => {
        // Make sure everything is filled in
        let errors = 0;
        [...this.refs.locationModal.querySelectorAll('[required]')].forEach(input => {
            if(!input.value) {
                input.classList.add('error');
                errors++;
                return;
            }
            input.classList.remove('error');
        });

        if(errors > 0) {
            return;
        }

        this.setState({savingLocation: true});

        let savingLocation = {...this.state.newLocation};

        if(savingLocation.country === 'US') {
            let [err, geo] = await this.getGeocoordinates();
            if(err) {
                if(err.response && err.response.body && err.response.body.addr_status === 'invalid') {
                    alert("Invalid address, please check again");
                }
                savingLocation.geospatial = null;
                savingLocation.latitude = null;
                savingLocation.longitude = null;
            } else {
                savingLocation.geospatial = geo.geospatial;
                savingLocation.latitude = geo.latitude;
                savingLocation.longitude = geo.longitude;
            }
        }

        // Append Dealer ID
        savingLocation.dealer_id = this.state.companyId;

        savingLocation.cdata = `{\\"wholesale\\" ${this.state.cdataF.wholesale} \\"consumer\\" ${this.state.cdataF.consumer}}`;
        //console.log('save loc cdata', savingLocation.cdata);



        // If part of updating, we need to remove the dealer_id
        if(this.state.editingLocationId) {
            delete savingLocation.dealer_id;
        }

        request.post('/api/company/location')
            .send(savingLocation)
            .then(resp => {
                //console.log(resp.body);
                let locations = [...this.state.locations];
                if(!this.state.editingLocationId) {
                    locations.push(resp.body.create_company_location);
                } else {
                    locations = locations.map(l => {
                        if(l.id === resp.body.update_company_location.id) {
                            return resp.body.update_company_location;
                        }
                        return l;
                    })
                }
                this.setState({
                    editingLocationId: null,
                    locations: locations,
                    newLocation: this.defaultNewLocation,
                    cdataF: this.defaultCdataFields,
                });
                this.closeNewLocationModal();

            })
            .catch(err => {
                console.log(err);
            });
    }

    editLocation = (id) => {
        let editLocation = this.state.locations.filter(l => l.id === id)[0];
        this.setState({
            editingLocationId: id,
            newLocation: {...editLocation},
            cdataF: {...editLocation.cdata}
        }, () => {
            this.openNewLocationModal();
        });
    }

    handleNewLocationInput = (event) => {
        let newLocation = {...this.state.newLocation};
        let value = event.target.value;
        if(event.target.type === 'checkbox') {
            value = event.target.checked;
        }
        newLocation[event.target.name] = value;
        this.setState({newLocation});

        //console.log('display loc', this.state.newLocation.display_location);
    }

    handleCdataInput = (event) => {
        let cdataF = {...this.state.cdataF};
        let value = event.target.checked;
        cdataF[event.target.name] = value;
        this.setState({cdataF});

        //console.log('wholesale', this.state.cdataF.wholesale);
        //console.log('consumer', this.state.cdataF.consumer);
    }

    getGeocoordinates = (address) => {
        if(!address) {
            address = {
                address: this.state.newLocation.address,
                country: this.state.newLocation.country,
                city: this.state.newLocation.city,
                state: this.state.newLocation.stateprovince,
                postal: this.state.newLocation.postal
            }
        }
        return request.post('/api/company/address/coordinates')
            .send({
                address: address
            }).then(resp => {
                return [null, resp.body];
            }).catch(err => {
                return [err];
            })
    }

    newLocationModal = () => {
        let country = '';
        let stateLabel = this.state.newLocation.country === 'CA' ? 'Province *' : 'State *';
        let states = this.state.newLocation.country === 'CA' ? caStateOpts : usStateOpts;
        return (
            <div id="locationModal" ref="locationModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title"><span id="locationModalTitle"></span>Add Location</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-group col-xs-12">
                                <label htmlFor="company_name">Company Name</label>
                                <input type="text" id="location_companyname" name="company_name" value={this.state.newLocation.company_name} onChange={this.handleNewLocationInput} className="form-control"/>
                            </div>
                            <div className="form-group col-xs-12">
                                <label htmlFor="website">Website *</label>
                                <input type="text" id="website" name="website" className="form-control" value={this.state.newLocation.website || ''} onChange={this.handleNewLocationInput} required={true}/>
                            </div>
                            <div className="form-group col-xs-12">
                                <label htmlFor="phone">Phone *</label>
                                <input type="text" id="phone" name="phone" className="form-control numeric-phone" value={this.state.newLocation.phone || ''} onChange={this.handleNewLocationInput} required={true} />
                            </div>
                            <div className="form-group col-xs-12">
                                <label htmlFor="country">Country *</label>
                                <select id="country" name="country" className="form-control" value={this.state.newLocation.country} onChange={this.handleNewLocationInput} required={true} >
                                    <option value="">Country *</option>
                                    <option value="US">USA</option>
                                    <option value="CA">Canada</option>
                                </select>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="address-verify">
                                    <div className="col-xs-4">
                                        <label htmlFor="address">Address *</label>
                                    </div>
                                    <div className="col-xs-8">
                                        <div id="verifiedAddress">
                                            <h5 id="address_verified"></h5>
                                            <h5 id="coordinates_verified"></h5>
                                        </div>
                                    </div>
                                </div>
                                <input type="text" id="address" name="address" className="form-control" value={this.state.newLocation.address} onChange={this.handleNewLocationInput} required={true} />
                            </div>
                            <div className="row">
                                <div className="form-group col-sm-4">
                                    <label htmlFor="city">City *</label>
                                    <input type="text" id="city" name="city" className="form-control" value={this.state.newLocation.city} onChange={this.handleNewLocationInput} required={true} />
                                </div>
                                <div id="us_states" className="form-group col-sm-4">
                                    <label htmlFor="stateprovince">{stateLabel}</label>
                                    <select id="stateprovince" name="stateprovince" className="form-control" value={this.state.newLocation.stateprovince} onChange={this.handleNewLocationInput} required={true} >
                                        {states.map((s, i) => {
                                            return (
                                                <option key={s.id} value={s.id}>{s.display}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                                <div className="form-group col-sm-4">
                                    <label htmlFor="postal">Postal Code *</label>
                                    <input type="text" id="postal" name="postal" className="form-control numeric-zip" value={this.state.newLocation.postal} onChange={this.handleNewLocationInput} required={true} />
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="display_location" className="toggle-check">
                                        <input type="checkbox" id="display_location" name="display_location" className="toggle-check-input" placeholder="Display Location?" onChange={this.handleNewLocationInput} checked={this.state.newLocation.display_location} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Display Location?</p>
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="wholesale" className="toggle-check">
                                        <input type="checkbox" id="wholesale" name="wholesale" className="toggle-check-input" placeholder="Wholesale?" onChange={this.handleCdataInput} checked={this.state.cdataF.wholesale} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Wholesale?</p>
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="consumer" className="toggle-check">
                                        <input type="checkbox" id="consumer" name="consumer" className="toggle-check-input" placeholder="Consumer?" onChange={this.handleCdataInput} checked={this.state.cdataF.consumer} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Consumer?</p>
                                </div>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="toggle-switch">
                                    <label htmlFor="showroom" className="toggle-check">
                                        <input type="checkbox" id="showroom" name="showroom" className="toggle-check-input" placeholder="Showroom?" onChange={this.handleNewLocationInput} checked={this.state.newLocation.showroom} />
                                        <span className="toggle-check-text"></span>
                                    </label>
                                    <p>Showroom?</p>
                                </div>
                            </div>
                            <button onClick={this.saveLocation} type="button" id="saveLocation" className="btn btn-default btn-primary" name="locationFormSubmit" disabled={this.state.savingLocation}>{this.state.savingLocation ? 'Saving...' : 'Save Location'}</button>
                            <button onClick={this.closeNewLocationModal} type="button" id="cancelLocation" className="btn btn-default btn-primary btn-danger">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    listenerCSVDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    listenerCSVDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.handleCSVUpload(e.dataTransfer.files);
    }

    handleCSVUpload = (files) => {
        if(!files || files.length === 0) {
            return;
        }
        let reader = new FileReader();
        reader.onload = (el) => {
            let result = el.target.result;
            let lines = result.split('\n'); // Split lines into arrays
            let fields = lines.shift().split(','); // get the fields setup correctly
            let invalidLocations = [];
            let locations = [];
            lines.forEach(line => {
                let values = line.split(',');
                if(values.length === fields.length) {
                    var locObj = {};
                    fields.forEach((key, index) => {
                        if(values[index]) {
                            let k = key.trim();
                            locObj[k] = values[index];
                            if(k == 'display_location') {
                                locObj[k] = values[index] == 1 ? true : false;
                            }
                            if(k == 'showroom') {
                                locObj[k] = values[index] == 1 ? true : false;
                            }
                            if(k == 'wholesale' ) {
                                locObj[k] = values[index] == 1 ? true : false;
                            }
                            if(k == 'consumer') {
                                locObj[k] = values[index] == 1 ? true : false;
                            }

                            locObj['cdata'] = `{\\"wholesale\\" ${locObj['wholesale']} \\"consumer\\" ${locObj['consumer']}}`;
                        }
                    });
                    delete locObj.wholesale;
                    delete locObj.consumer;
                    locations.push(locObj);
                } else {
                    // Trying to create an object that doesn't match
                    invalidLocations.push(line);
                }
            });

            if(locations.length > 0) {
                this.setState({csvUploading: true})
                this.uploadCSVLocations(locations);
            }
            if(invalidLocations.length > 0) {
                let data = encodeURI('data:text/csv;charset=utf-8,' + invalidLocations.join('\n'));
                let link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "invalid_locations.csv");
                document.body.appendChild(link);
                link.click();
            }
        };
        reader.readAsText(files[0]);
    };

    uploadCSVLocations = async (locations) => {

        let savedLocations = [];
        let failedLocations = [];
        for(let location of locations) {
            let savingLocation = location;

            if(savingLocation.country === 'US') {
                let address = address = {
                    address: savingLocation.address,
                    country: savingLocation.country,
                    city: savingLocation.city,
                    state: savingLocation.stateprovince,
                    postal: savingLocation.postal
                };
                let [err, geo] = await this.getGeocoordinates(address);
                if(err) {
                    if(err.response && err.response.body && err.response.body.addr_status === 'invalid') {
                        failedLocations.push(location);
                    }
                    savingLocation.geospatial = null;
                    savingLocation.latitude = null;
                    savingLocation.longitude = null;
                } else {
                    savingLocation.geospatial = geo.geospatial;
                    savingLocation.latitude = geo.latitude;
                    savingLocation.longitude = geo.longitude;
                }
            }

            // Append Dealer ID
            savingLocation.dealer_id = this.state.companyId;

           // console.log('saved locs', savedLocations);


            await new Promise(resolve => {
                request.post('/api/company/location')
                    .send(savingLocation)
                    .then(resp => {
                        //console.log(resp.body);
                        savedLocations.push(resp.body.create_company_location);
                        resolve();
                    })
                    .catch(err => {
                        console.log(err);
                        failedLocations.push(location);
                        resolve();
                    });
            });
        }

        this.setState({
            locations: [...this.state.locations, ...savedLocations],
            csvUploading: false
        });

        // Unable to save to these locations
        if(failedLocations.length > 0) {
            let data = encodeURI('data:text/csv;charset=utf-8,' + failedLocations.map(v => v.join(',')).join('\n'));
            let link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "failed_locations.csv");
            document.body.appendChild(link);
            link.click();
        }

    }

    csvUpload = () => {
        return (
            <div id="csvUploadForm" className="csv-upload" onDragOver={this.listenerCSVDrag} onDrop={this.listenerCSVDrop}>
                <input type="file" name="file" onChange={(e) => this.handleCSVUpload(e.target.files)} id="file" className="csvFile" />
                <label htmlFor="file">
                    <div>
                        <p className="upload-plus">+</p>
                        <p className="upload-add">Add Data</p>
                        <p>Click here or Drag and Drop CSV here</p>
                    </div>
                    {this.state.csvUploading && <Loader /> }
                </label>
            </div>
        )
    };


    uploadResellerCertificate = () => {
        this.refs.onUploadUserFile.click();
        this.__FILETYPE__ = 'certificate';
        this.setState({uploadingCertificate: true});
    };

    onUploadUserFile = async (evt) => {
        this.__FILE__ = evt.target.files;

        const formData = new FormData();
        // Save our new file name as `profile-ID.EXT`

        let epox = (new Date).getTime();
        if(this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null" ) {
            const splitted = this.state.companyD.reseller_certification_path.split('/');
            const uniC =  splitted[splitted.length-1].replace(/[^0-9]/g, '');
            //console.log('uniCert', uniC);
            epox = uniC;
        }

        //console.log('epox', epox)

        let fileName = `${this.__FILETYPE__}-${epox}.${this.__FILE__[0].name.split('.').pop()}`
        formData.append('file', this.__FILE__[0], fileName);
        let location = await request.post(`/api/user/upload/${this.__FILETYPE__}`)
            .send(formData)
            .then(resp => {
                //console.log(resp);
                return resp.body.Location;
            })
            .catch(err => {
                console.log(err);
                this.__FILE__ = null;
                this.__FILETYPE__ = null;
            });

        //console.log('done uploading');
        let field = this.__FILETYPE__ === 'profile' ? 'logo_path' : 'reseller_certification_path';
        let payload = {
            [field]: location
        };
        this.updateCompany(payload);
    };

    updateCompany = (payload) => {
        request.put(`/api/company/${this.state.companyD.id}`)
            .send(payload)
            .then(resp => {
                this.setState({
                    companyD: resp.body.update_company,
                    uploadingProfile: false,
                    uploadingCertificate: false
                });
            })
            .catch(err => {
                console.log(err);
            });
    };

    generateGeopostal = async (lat, long, evt) => {
        evt.preventDefault();
        let geoloc = await request.post(`/api/company/address/${lat}/${long}`)
            .then(resp => {
                //console.log('response',resp.body.geospatial);
                return resp.body.geospatial;

            })
            .catch(err => {
                console.log(err);
            });

        let latitude = parseFloat(lat);
        let longitude = parseFloat(long);
        //console.log('geoloc', geoloc);

        let payload = {
            "geospatial": geoloc,
            "latitude": latitude,
            "longitude": longitude,
        };
        //console.log('payload', payload);
        this.updateCompanyGeoloc(payload);
    };

    updateCompanyGeoloc = (payload) => {
        request.put(`/api/company/${this.state.companyD.id}`)
            .send(payload)
            .then(resp => {
                this.setState({
                    companyD: resp.body.update_company,
                    proCoords: true,
                });
            })
            .catch(err => {
                console.log(err);
            });
    };

    render() {

        //console.log('compD - res cert', this.state.companyD.reseller_certification_path);
        //console.log('compD', this.state.companyD);
        //console.log('uploading cert', this.state.uploadingCertificate);

        //console.log('wholesale state render', this.state.cdataF.wholesale);
       // console.log('consumer state render', this.state.cdataF.consumer);
        //console.log('display loc', this.state.newLocation.display_location);

        let proVerified = false;
        if(this.state.compLoaded === true && this.state.companyD.latitude !== undefined && this.state.companyD.longitude !== undefined) {
            proVerified = true;
        } else {
            proVerified = this.state.proCoords;
        }

        //console.log('proCoords', this.state.proCoords);
        //console.log('locations', this.state.locations);
       // console.log('saving locations', this.state.savingLocation);
       // console.log('new locations', this.state.newLocation);
        //console.log("locations", this.state.locations);

        const {id, companyId} = this.props;

        //console.log("props id", this.props.id);
        //console.log("comp id", this.props.companyId);

        const countryOpts = [
            {id: '', display: 'Select Country'},
            {id: 'US', display: 'USA'},
            {id: 'CA', display: 'Canada'},
        ];

        const caStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alberta'},
            { id: 'BC', display: 'British Columbia'},
            { id: 'MA', display: 'Manitoba'},
            { id: 'NB', display: 'New Brunswik'},
            { id: 'NL', display: 'Newfoundlend and Labrador'},
            { id: 'NS', display: 'Nova Scotia'},
            { id: 'ON', display: 'Ontario'},
            { id: 'PEI', display: 'Price Edward Island'},
            { id: 'QU', display: 'Quebeck'},
            { id: 'SA', display: 'Saskatchewan'},
        ];

        const usStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alabama'},
            { id: 'AK', display: 'Alaska'},
            { id: 'AZ', display: 'Arizona'},
            { id: 'AR', display: 'Arkansas'},
            { id: 'CA', display: 'California'},
            { id: 'CO', display: 'Colorado'},
            { id: 'CT', display: 'Connecticut'},
            { id: 'DC', display: 'District of Columbia'},
            { id: 'DE', display: 'Delaware'},
            { id: 'FL', display: 'Florida'},
            { id: 'GA', display: 'Georgia'},
            { id: 'HI', display: 'Hawaii'},
            { id: 'ID', display: 'Idaho'},
            { id: 'IA', display: 'Iowa'},
            { id: 'IL', display: 'Illinois'},
            { id: 'IN', display: 'Indiana'},
            { id: 'KS', display: 'Kansas'},
            { id: 'KY', display: 'Kentucky'},
            { id: 'LA', display: 'Louisiana'},
            { id: 'ME', display: 'Maine'},
            { id: 'MD', display: 'Maryland'},
            { id: 'MA', display: 'Massachusetts'},
            { id: 'MI', display: 'Michigan'},
            { id: 'MN', display: 'Minnesota'},
            { id: 'MS', display: 'Mississippi'},
            { id: 'MO', display: 'Missouri'},
            { id: 'MT', display: 'Montana'},
            { id: 'NE', display: 'Nebraska'},
            { id: 'NH', display: 'New Hampshire'},
            { id: 'NJ', display: 'New Jersey'},
            { id: 'NM', display: 'New Mexico'},
            { id: 'NV', display: 'Nevada'},
            { id: 'NY', display: 'New York'},
            { id: 'NC', display: 'North Carolina'},
            { id: 'ND', display: 'North Dakota'},
            { id: 'OH', display: 'Ohio'},
            { id: 'OK', display: 'Oklahoma'},
            { id: 'OR', display: 'Oregon'},
            { id: 'PA', display: 'Pennsylvania'},
            { id: 'RI', display: 'Rhode Island'},
            { id: 'SC', display: 'South Carolina'},
            { id: 'SD', display: 'South Dakota'},
            { id: 'TN', display: 'Tennessee'},
            { id: 'TX', display: 'Texas'},
            { id: 'UT', display: 'Utah'},
            { id: 'VT', display: 'Vermont'},
            { id: 'VA', display: 'Virginia'},
            { id: 'WA', display: 'Washington'},
            { id: 'WV', display: 'West Virginia'},
            { id: 'WI', display: 'Wisconsin'},
            { id: 'WY', display: 'Wyoming'}
        ];

        const segmentOps = [
            {id: "commerical", display: "Commerical"},
            {id: "home_automation", display: "Home Automation"},
            {id: "industrial", display: "Industrial"},
            {id: "residential", display: "Residential"},
        ];

        const servicesOpts = [
            {id: "audio_visual", display: "Audio/Visual"},
            {id: "high_voltage_install", display: "High Voltage Install"},
            {id: "low_voltage_install", display: "Low Voltage Install"},
            {id: "smart_home_install", display: "Smart Home Install"},
            {id: "wholehome_automation", display: "Wholehome Automation"},
        ];

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];

        const businessOpts = [
            {id: "", display: "Business Type*"},
            {id: "av_solution_provider", display: "AV Solution Provider"},
            {id: "electrical_wholesale", display: "Electrical Wholesale"},
            {id: "lighting_showrooml", display: "Lighting Showroom"},
            {id: "lighting_wholesale", display: "Lighting Wholesale"},
        ];

        const roleOptions = [
            {id: "admin", display: "Admin", description: "Can edit and approve resellers"},
            {id: "architect", display: " Architect/Designer", description: "Architect or Designer"},
            {id: "developer", display: "Developer", description:"Developer"},
            {id: "distributor", display: "Distributor", description: "Can manage resellers"},
            {id: "installer", display: "Employee", description: "Basic NOON Pro access"},
            {id: "owner", display: "Owner", description: "Can create admin users"},
            {id: "user", display: "Reseller", description: "Can manage installers"},
        ];

        const phoneRegExp = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

        const ProfileSchema = Yup.object().shape({
            email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid').required('This value is required.'),
            country: Yup.string().required('This value is required.'),
            address: Yup.string().required('This value is required.'),
            city: Yup.string().required('This value is required.'),
            state: Yup.string().required('This value is required.'),
            postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            //years_in_business: Yup.string().required('This value is required.'),
            coverage_segments: Yup.string().required('This value is required.'),
            services_offered: Yup.string().required('This value is required.'),
            //number_of_employees: Yup.string().required('This value is required.'),
            business_type: Yup.string().required('This value is required'),
           // established: Yup.string().required('This value is required.'),
            //sales_name: Yup.string().required('This value is required.'),
            sales_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            sales_email: Yup.string().email('This value should be a valid email.'),
            //accounts_name: Yup.string().required('This value is required.'),
            accounts_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            accounts_email: Yup.string().email('This value should be a valid email.'),
            //logistics_name: Yup.string().required('This value is required.'),
            logistics_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            logistics_email: Yup.string().email('This value should be a valid email.'),
            bank_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            bank_email: Yup.string().email('This value should be a valid email.'),
            first_creditref_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            first_creditref_email: Yup.string().email('This value should be a valid email.'),
            second_creditref_phone: Yup.string().matches(phoneRegExp, 'Phone number should be valid'),
            second_creditref_email: Yup.string().email('This value should be a valid email.'),
        });

        let hearAboutNoon = "";
        if(this.state.cData.additional_information_hearAboutNoon != "" && this.state.cData.additional_information_hearAboutNoon != null) {
            hearAboutNoon = this.state.cData.additional_information_hearAboutNoon.split(',');
        }

        let subsidiaryName = "";
        if(this.state.cData.subsidiary_name != 'undefined') {
            subsidiaryName = this.state.cData.subsidiary_name;
        };

        let mailingAddress = "";
        if(this.state.cData.mailing_address != 'undefined') {
            mailingAddress = this.state.cData.mailing_address;
        };

        let mailingCity = "";
        if(this.state.cData.mailing_city != 'undefined') {
            mailingCity = this.state.cData.mailing_city;
        };

        let mailingPostal = "";
        if(this.state.cData.mailing_postal != 'undefined') {
            mailingPostal = this.state.cData.mailing_postal;
        };

        let Duns = "";
        if(this.state.cData.duns != 'undefined') {
            Duns = this.state.cData.duns;
        };

        let bankName = "";
        if(this.state.cData.bank_name != 'undefined') {
            bankName = this.state.cData.bank_name;
        };

        let bankAddress = "";
        if(this.state.cData.bank_address != 'undefined') {
            bankAddress = this.state.cData.bank_address;
        };

        let bankRepresentative = "";
        if(this.state.cData.bank_representative != 'undefined') {
            bankRepresentative = this.state.cData.bank_representative;
        };

        let bankPhone = "";
        if(this.state.cData.bank_phone != 'undefined') {
            bankPhone = this.state.cData.bank_phone;
        };

        let bankEmail = "";
        if(this.state.cData.bank_email != 'undefined') {
            bankEmail = this.state.cData.bank_email;
        };

        let firstCname = "";
        if(this.state.cData.first_creditref_name != 'undefined') {
            firstCname = this.state.cData.first_creditref_name;
        };

        let firstCaddress = "";
        if(this.state.cData.first_creditref_address != 'undefined') {
            firstCaddress = this.state.cData.first_creditref_address;
        };

        let firstCrepresentative = "";
        if(this.state.cData.first_creditref_representative != 'undefined') {
            firstCrepresentative = this.state.cData.first_creditref_representative;
        };

        let firstCphone = "";
        if(this.state.cData.first_creditref_phone != 'undefined') {
            firstCphone = this.state.cData.first_creditref_phone;
        };

        let firstCemail = "";
        if(this.state.cData.first_creditref_email != 'undefined') {
            firstCemail = this.state.cData.first_creditref_email;
        };

        let secondCname = "";
        if(this.state.cData.second_creditref_name != 'undefined') {
            secondCname = this.state.cData.second_creditref_name;
        };

        let secondCaddress = "";
        if(this.state.cData.second_creditref_address != 'undefined') {
            secondCaddress = this.state.cData.second_creditref_address;
        };

        let secondCrepresentative = "";
        if(this.state.cData.second_creditref_representative != 'undefined') {
            secondCrepresentative = this.state.cData.second_creditref_representative;
        };

        let secondCphone = "";
        if(this.state.cData.second_creditref_phone != 'undefined') {
            secondCphone = this.state.cData.second_creditref_phone;
        };

        let secondCemail = "";
        if(this.state.cData.second_creditref_email != 'undefined') {
            secondCemail = this.state.cData.second_creditref_email;
        };

        let numberOfStores = "";
        if(this.state.companyD.number_of_stores != 'null') {
            numberOfStores = this.state.companyD.number_of_stores;
        }

        const columns = [

            {
                Header: 'Id',
                id: 'id',
                accessor: 'id',
                className: 'react--tb--styles',
                show: true
            },
            {
                Header: 'Company Name',
                id: 'company_name',
                accessor: 'company_name',
                className: 'react--tb--styles',
            },
            {
                Header: 'Address',
                id: 'address',
                accessor: loc => <div><div>{loc.address}</div><div>{loc.city}, {loc.stateprovince} {loc.postal}</div></div>,
                className: 'react--tb--styles',
            },
            {
                Header: 'Country',
                id: 'country',
                accessor: 'country',
                className: 'react--tb--styles',
            },
            {
                Header: 'Phone',
                id: 'phone',
                accessor: 'phone',
                className: 'react--tb--styles',
            },
            {
                Header: 'Website',
                id: 'website',
                accessor: 'website',
                className: 'react--tb--styles',
            },
            {
                Header: 'Displayed',
                id: 'displayed',
                accessor: loc => <span className={loc.display_location ? 'approved' : 'declined'}></span>,
                className: 'text-center',
            },
            {
                Header: 'View',
                width: 60,
                Cell:({row, original}) => {
                    return (
                        <button onClick={e => this.editLocation(original.id)} className='view-btn-icon'>
                            <i className='ion-edit'></i>
                        </button>
                    )
                }

            },
            {
                Header: 'Delete',
                className: 'action--tb--styles',
                width: 60,
                Cell: ({row, original}) => {
                    return (
                        <button id="delete" className='delete-btn-icon' onClick={(e) => this.showAlert(e, row, original.id)}>
                            <i className='ion-android-delete'></i>
                        </button>)
                }
            },

        ];
        const pageOpts = [10, 25, 50, 100];

        //console.log('update', this.state.updateFlag);
        //console.log('edit', this.state.editingProfile);
        //console.log('error', this.state.isError);
        //console.log('cdata', this.state.cData);



        return(
            <div>
                {this.state.userLoaded === true && this.state.compLoaded === true && this.state.cDataLoaded === true ?
                    <div className='profile-data'>
                        <div className='short-desc'>
                            <h5>{this.state.companyD.name}</h5>
                            <p>{this.state.companyD.address}, {this.state.companyD.city}, {this.state.companyD.state}</p>
                            <a className='user--domain--link'
                               href={this.state.companyD.domain}>{this.state.companyD.domain}</a>
                            <br/>
                            <button className='edit-p-button' onClick={this.editProfile}>Edit Profile</button>
                            <section>
                                <input ref="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                            </section>
                        </div>
                        <div className='profile-details'>
                            {this.state.editingProfile === true ?
                                <Formik

                                    initialValues={{
                                        role: this.state.userD.role.name,
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        latitude: this.state.companyD.latitude,
                                        longitude: this.state.companyD.longitude,
                                        domain: this.state.companyD.domain,
                                        reseller_certification: this.state.companyD.reseller_certification,
                                        csm: this.state.userD.company.csm && this.state.userD.company.csm.id || "",

                                        years_in_business: this.state.companyD.years_in_business,
                                        coverage_segments: this.state.companyD.coverage_segments.split(','),
                                        services_offered: this.state.companyD.services_offered.split(','),
                                        number_of_employees: this.state.companyD.number_of_employees,

                                        dealer_finder: this.state.companyD.dealer_finder,
                                        where_to_buy: this.state.companyD.where_to_buy,
                                        provide_staff_training: false,
                                        experience_with_noon: this.state.companyD.experience_with_noon,
                                        additional_information_hearAboutNoon: hearAboutNoon,
                                        business_type: this.state.companyD.business_type,
                                        number_of_stores: numberOfStores,

                                        subsidiary_name: subsidiaryName,
                                        mailing_address: mailingAddress,
                                        mailing_city: mailingCity,
                                        mailing_state: this.state.cData.mailing_state,
                                        mailing_postal: mailingPostal,
                                        mailing_country: this.state.cData.mailing_country,
                                        established: this.state.cData.established,
                                        duns: Duns,
                                        sales_name: this.state.cData.sales_name,
                                        sales_phone: this.state.cData.sales_phone,
                                        sales_email: this.state.cData.sales_email,
                                        accounts_name: this.state.cData.accounts_name,
                                        accounts_phone: this.state.cData.accounts_phone,
                                        accounts_email: this.state.cData.accounts_email,
                                        logistics_name: this.state.cData.logistics_name,
                                        logistics_phone: this.state.cData.logistics_phone,
                                        logistics_email: this.state.cData.logistics_email,
                                        bank_name: bankName,
                                        bank_address: bankAddress,
                                        bank_representative: bankRepresentative,
                                        bank_phone: bankPhone,
                                        bank_email: bankEmail,
                                        first_creditref_name: firstCname,
                                        first_creditref_address: firstCaddress,
                                        first_creditref_representative: firstCrepresentative,
                                        first_creditref_phone: firstCphone,
                                        first_creditref_email: firstCemail,
                                        second_creditref_name: secondCaddress,
                                        second_creditref_address: secondCaddress,
                                        second_creditref_representative: secondCrepresentative,
                                        second_creditref_phone: secondCphone,
                                        second_creditref_email: secondCemail,
                                    }}
                                    enableReinitialize={true}
                                    validationSchema={ProfileSchema}
                                    onSubmit={(values, actions) => {
                                        let yearsInB = parseInt(values.years_in_business, 10);
                                        let numberOfE = parseInt(values.number_of_employees, 10);

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }
                                       // console.log('about N', hearedAbout);
                                        let cSegments = "";
                                        if (values.coverage_segments != "" && values.coverage_segments != []) {
                                            cSegments = values.coverage_segments.join(",")
                                        }
                                       // console.log('s segs', cSegments);

                                        let servicesO = "";
                                        if (values.services_offered != "" && values.services_offered != []) {
                                            servicesO = values.services_offered.join(",")
                                        }
                                       // console.log('services', servicesO);

                                        let expWnoon = false;
                                        if(values.experience_with_noon === true) {
                                            expWnoon = true
                                        }

                                        let dealerF = false;
                                        if(values.dealer_finder === true) {
                                            dealerF = true
                                        }

                                        let wTB = false;
                                        if(values.where_to_buy === true) {
                                            wTB = true
                                        }

                                        let staffTr = false;
                                        if(values.provide_staff_training === true) {
                                            staffTr = true
                                        }


                                        return Promise.all([
                                            request.post(`/api/updateuser/${this.props.id}`)
                                                .send({
                                                    role: values.role,
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,

                                                    subsidiary_name: values.subsidiary_name,
                                                    mailing_address: values.mailing_address,
                                                    mailing_city: values.mailing_city,
                                                    mailing_state: values.mailing_state,
                                                    mailing_postal: values.mailing_postal,
                                                    mailing_country: values.mailing_country,
                                                    established: values.established,
                                                    duns: values.duns,
                                                    sales_name: values.sales_name,
                                                    sales_phone: values.sales_phone,
                                                    sales_email: values.sales_email,
                                                    accounts_name: values.accounts_name,
                                                    accounts_phone: values.accounts_phone,
                                                    accounts_email: values.accounts_email,
                                                    logistics_name: values.logistics_name,
                                                    logistics_phone: values.logistics_phone,
                                                    logistics_email: values.logistics_email,
                                                    bank_name: values.bank_name,
                                                    bank_address: values.bank_address,
                                                    bank_representative: values.bank_representative,
                                                    bank_phone: values.bank_phone,
                                                    bank_email: values.bank_email,
                                                    first_creditref_name: values.first_creditref_name,
                                                    first_creditref_address: values.first_creditref_address,
                                                    first_creditref_representative: values.first_creditref_representative,
                                                    first_creditref_phone: values.first_creditref_phone,
                                                    first_creditref_email: values.first_creditref_email,
                                                    second_creditref_name: values.second_creditref_name,
                                                    second_creditref_address: values.second_creditref_address,
                                                    second_creditref_representative: values.second_creditref_representative,
                                                    second_creditref_phone: values.second_creditref_phone,
                                                    second_creditref_email: values.second_creditref_email,
                                                }),
                                            request.post(`/api/company/${this.props.companyId}`)
                                                .send({
                                                    name: values.name,
                                                    dba: values.dba,
                                                    primary_jobtitle: values.primary_jobtitle,
                                                    phone: values.phone,
                                                    country: values.country,
                                                    address: values.address,
                                                    city: values.city,
                                                    state: values.state,
                                                    postal: values.postal,
                                                    domain: values.domain,
                                                    reseller_certification: values.reseller_certification,
                                                    years_in_business: yearsInB,
                                                    coverage_segments: cSegments,
                                                    services_offered: servicesO,
                                                    number_of_employees: numberOfE,
                                                    dealer_finder: dealerF,
                                                    where_to_buy: wTB,
                                                    experience_with_noon: expWnoon,
                                                    provide_staff_training: staffTr,
                                                    business_type: values.business_type,
                                                    number_of_stores: values.number_of_stores,
                                                    csm: parseInt(values.csm),
                                                    coverage_range: null,

                                                })
                                        ])
                                            .then(data => {
                                                //console.log('finished user call');
                                                //console.log(data);
                                            })
                                            .then(resp => {
                                                this.setState({updateFlag: true})
                                            })
                                            .catch(err => {
                                                console.error(err);
                                                this.setState({isError: true});
                                            });

                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,

                                      }) => (
                                        <Form className='my-f-form'>
                                            <h3>Authorized Reseller Portal Permissions</h3>
                                            <FieldArray
                                                name='role'
                                                render={arrayHelpers => (
                                                    <div className='toggle-radio-gr-table'>
                                                        {roleOptions.map(option => (
                                                            <div key={option.id} className='toggle-radio-gr-container'>
                                                                <input
                                                                    name='role'
                                                                    type='checkbox'
                                                                    className='toggle--radio--btn'
                                                                    value={option.id}
                                                                    checked={values.role.includes(option.id)}
                                                                    onChange={() => {
                                                                        setFieldValue('role', option.id)
                                                                    }}
                                                                />
                                                                <div className='toggle--radio-content'>
                                                                    <div className='toggle--radio--title'>{option.display}</div>
                                                                    <div className='toggle--radio--subtitle'> {option.description} </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                            <h3>Primary Contact Information</h3>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}/>
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div
                                                                className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div
                                                                className='f-field-errors'>{errors.last_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.name}
                                            />
                                            {errors.name && touched.name ?
                                                (<div className='f-field-errors'>{errors.name}</div>) : null
                                            }

                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.dba}
                                            />
                                            {errors.dba && touched.dba ?
                                                (<div className='f-field-errors'>{errors.dba}</div>) : null
                                            }

                                            <label className='form-f-label'>If Subsidiary, Name of Parent Company</label>
                                            <Field
                                                name='subsidiary_name'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Subsidiary Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.subsidiary_name}
                                            />

                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.primary_jobtitle}
                                            />
                                            {errors.primary_jobtitle && touched.primary_jobtitle ?
                                                (<div className='f-field-errors'>{errors.primary_jobtitle}</div>) : null
                                            }

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {errors.phone && touched.phone ?
                                                (<div className='f-field-errors'>{errors.phone}</div>) : null
                                            }

                                            <h4 className='profile-data-sub-section'>Company Billing Address</h4>

                                            <label className='form-f-label'>Country*</label>
                                            <Field name='country' component='select'
                                                   className='single-choice-selector'>
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.country && touched.country ?
                                                (<div className='f-field-errors'>{errors.country}</div>) : null
                                            }

                                            <section className='flex-text-flags-holder'>
                                                <div className ='flags-text'
                                                     style={{
                                                         color: proVerified === true? '#39B54A': '#F7941E',
                                                     }}>
                                                    <span
                                                        className='tb-status-circle'
                                                        style={{
                                                            background: proVerified === true? '#39B54A': '#F7941E',
                                                        }}>

                                                    </span>
                                                    PRO FINDER COORDINATES
                                                </div>
                                                <div className='flags-text'
                                                     style={{
                                                         color: this.state.companyD.address_status === "valid"? '#39B54A': '#F7941E',
                                                     }}>
                                                     <span
                                                         className='tb-status-circle'
                                                         style={{
                                                             background: this.state.companyD.address_status === "valid"? '#39B54A': '#F7941E',
                                                         }}>
                                                     </span>
                                                    ADDRESS VERIFIED
                                                </div>
                                            </section>


                                            <label className='form-f-label'>Address*</label>
                                            <Field
                                                name='address'
                                                component='input'
                                                className={errors.address && touched.address ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Address*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.address}
                                            />
                                            {errors.address && touched.address ?
                                                (<div className='f-field-errors'>{errors.address}</div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>City*</label>
                                                    <Field
                                                        name='city'
                                                        component='input'
                                                        className={errors.city && touched.city ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='City*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.city}
                                                    />
                                                    {errors.city && touched.city ?
                                                        (<div className='f-field-errors'>{errors.city}</div>) : null
                                                    }
                                                </div>

                                                {values.country === 'US' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <Field name='state' component='select'
                                                               className='state-selector' placeholder='State'>
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        {errors.state && touched.state ?
                                                            (<div
                                                                className='f-field-errors'>{errors.state}</div>) : null
                                                        }
                                                    </div> :
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <Field name='state' component='select'
                                                               className='state-selector' placeholder='State'>
                                                            {caStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        {errors.state && touched.state ?
                                                            (<div
                                                                className='f-field-errors'>{errors.state}</div>) : null
                                                        }
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <Field
                                                        name='postal'
                                                        component='input'
                                                        className={errors.postal && touched.postal ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.postal}
                                                    />
                                                    {errors.postal && touched.postal ?
                                                        (<div className='f-field-errors'>{errors.postal}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>Latitude*</label>
                                                    <Field
                                                        name='latitude'
                                                        component='input'
                                                        className={errors.latitude && touched.latitude ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Latitude*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.latitude}
                                                    />
                                                    {errors.latitude && touched.latitude ?
                                                        (<div className='f-field-errors'>{errors.latitude}</div>) : null
                                                    }
                                                </div>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>Longitude*</label>
                                                    <Field
                                                        name='longitude'
                                                        component='input'
                                                        className={errors.longitude && touched.longitude ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Longitude*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.longitude}
                                                    />
                                                    {errors.longitude && touched.longitude ?
                                                        (<div className='f-field-errors'>{errors.longitude}</div>) : null
                                                    }
                                                </div>
                                                <div className='flex-field-container last-btn'>
                                                    <section>
                                                        <a className='geo-p-button' onClick={(evt) => this.generateGeopostal(values.latitude, values.longitude, evt)}>Generate Geopostal Data</a>
                                                    </section>
                                                </div>

                                            </div>

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='where_to_buy'
                                                    checked={values.where_to_buy}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Show in Where To Buy Listings?</p>
                                            </div>

                                            <h4 className='profile-data-sub-section'>Company Mailing Address (if different from Billing Address above)</h4>

                                            <label className='form-f-label'>Country</label>
                                            <select
                                                name='mailing_country'
                                                className='single-choice-selector'
                                                value={values.mailing_country}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                {countryOpts.map(option => (
                                                    <option key={`mailing_country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className='form-f-label'>Address</label>
                                            <input
                                                name='mailing_address'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Address'
                                                value={values.mailing_address}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>City</label>
                                                    <input
                                                        name='mailing_city'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='City'
                                                        value={values.mailing_city}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />

                                                </div>

                                                {this.state.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        >
                                                            {caStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>:
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        >
                                                            {usStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code</label>
                                                    <input
                                                        name='mailing_postal'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='Postal Code'
                                                        value={values.mailing_postal}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Website*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Year Established*</label>
                                            <Field
                                                name='established'
                                                component='input'
                                                className={errors.established && touched.established ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Year Established*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.established}
                                            />
                                            {errors.established && touched.established ?
                                                (<div className='f-field-errors'>{errors.established}</div>) : null
                                            }

                                            <label className='form-f-label'>D&B/DUNS Number</label>
                                            <Field
                                                name='duns'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='D&B/DUNS Number'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.duns}
                                            />

                                            <label className='form-f-label'>Reseller Certification Number</label>
                                            <input className='form-f-field'
                                                   type='text'
                                                   name='reseller_certification'
                                                   placeholder='Reseller Certification Number'
                                                   onChange={handleChange}
                                                   onBlur={handleBlur}
                                                   value={values.reseller_certification}
                                            />

                                            <p className='disclaimer--copy'>Specify your reseller tax number and state
                                                above and upload a copy of your reseller certificate below.
                                                If you sell in multiple states, please upload them as a zip file. If no
                                                reseller certificate is provided, applicable sales tax will be charged
                                                on your purchases.</p>
                                            <br/>
                                            <section>
                                                <a className='edit-p-button' onClick={this.uploadResellerCertificate}>{this.state.uploadingCertificate ? 'Saving...' :  'Upload Certificate'}</a>
                                                <input name="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                                            </section>
                                            <br/>

                                            {this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null"?
                                                <a className='edit-p-button' href={this.state.companyD.reseller_certification_path} target="_blank">View Certificate</a>: null
                                            }

                                            <label className='form-f-label'>Years in Business*</label>
                                            <Field
                                                name='years_in_business'
                                                component='input'
                                                className={errors.years_in_business && touched.years_in_business ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Years in Business*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.years_in_business}
                                            />
                                            {errors.years_in_business && touched.years_in_business ?
                                                (<div
                                                    className='f-field-errors'>{errors.years_in_business}</div>) : null
                                            }

                                            <label className='form-f-label'>Business Type*</label>
                                            <Field name='business_type' component='select'
                                                   className='single-choice-selector'>
                                                {businessOpts.map(option => (
                                                    <option key={`business_type-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.business_type && touched.business_type ?
                                                (<div className='f-field-errors'>{errors.business_type}</div>) : null
                                            }

                                            <label className='form-f-label'>Number of Stores/Branches</label>
                                            <Field
                                                name='number_of_stores'
                                                component='input'
                                                className={errors.number_of_stores && touched.number_of_stores ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Stores/Branches'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.number_of_stores}
                                            />
                                            {errors.number_of_stores && touched.number_of_stores ?
                                                (<div className='f-field-errors'>{errors.number_of_stores}</div>) : null
                                            }

                                            <h3 className='profile-data-section'>Contact Information</h3>

                                            <p className='disclaimer--copy'>Please provide appropriate contact information for the departments listed below.
                                                This will ensure we are communicating with the appropriate members of your business. </p>

                                            <h5 className='profile-data-sub-section'>Sales</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='sales_name'
                                                className={errors.sales_name && touched.sales_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.sales_name}/>
                                            {errors.sales_name && touched.sales_name ?
                                                (<div className='f-field-errors'>{errors.sales_name} </div>) : null
                                            }

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='sales_phone'
                                                className={errors.sales_phone && touched.sales_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.sales_phone}/>
                                            {errors.sales_phone && touched.sales_phone ?
                                                (<div className='f-field-errors'>{errors.sales_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='sales_email'
                                                className={errors.sales_email && touched.sales_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.sales_email}/>
                                            {errors.sales_email && touched.sales_email ?
                                                (<div className='f-field-errors'>{errors.sales_email} </div>) : null
                                            }

                                            <h5 className='profile-data-sub-section'>Accounts Payable</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='accounts_name'
                                                className={errors.accounts_name && touched.accounts_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.accounts_name}/>
                                            {errors.accounts_name && touched.accounts_name ?
                                                (<div className='f-field-errors'>{errors.accounts_name} </div>) : null
                                            }

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='accounts_phone'
                                                className={errors.accounts_phone && touched.accounts_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.accounts_phone}/>
                                            {errors.accounts_phone && touched.accounts_phone ?
                                                (<div className='f-field-errors'>{errors.accounts_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='accounts_email'
                                                className={errors.accounts_email && touched.accounts_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.accounts_email}/>
                                            {errors.accounts_email && touched.accounts_email ?
                                                (<div className='f-field-errors'>{errors.accounts_email} </div>) : null
                                            }

                                            <h5 className='profile-data-sub-section'>Shipping & Logistics</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='logistics_name'
                                                className={errors.logistics_name && touched.logistics_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.logistics_name}/>
                                            {errors.logistics_name && touched.logistics_name ?
                                                (<div className='f-field-errors'>{errors.logistics_name} </div>) : null
                                            }

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='logistics_phone'
                                                className={errors.logistics_phone && touched.logistics_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.logistics_phone}/>
                                            {errors.logistics_phone && touched.logistics_phone ?
                                                (<div className='f-field-errors'>{errors.logistics_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='logistics_email'
                                                className={errors.logistics_email && touched.logistics_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.logistics_email}/>
                                            {errors.logistics_email && touched.logistics_email ?
                                                (<div className='f-field-errors'>{errors.logistics_email} </div>) : null
                                            }

                                            <h3 className='profile-data-section'>Bank & Credit References</h3>

                                            <p className='disclaimer--copy'>If you would like credit terms to be extended to your business please provide your bank and credit reference(s) for credit review by NOON.
                                                If no credit needs to be extended (i.e., paying by credit card) please leave blank.</p>

                                            <h5 className='profile-data-sub-section'>Bank Reference</h5>

                                            <label className='form-f-label'>Bank Name</label>
                                            <Field
                                                name='bank_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_name}/>


                                            <label className='form-f-label'>Bank Address</label>
                                            <Field
                                                name='bank_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Address'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_address}/>

                                            <label className='form-f-label'>Bank Contact Representative</label>
                                            <Field
                                                name='bank_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Representative'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_representative}/>
                                            
                                            <label className='form-f-label'>Bank Contact Phone Number</label>
                                            <Field
                                                name='bank_phone'
                                                className={errors.bank_phone && touched.bank_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_phone}/>
                                            {errors.bank_phone && touched.bank_phone ?
                                                (<div className='f-field-errors'>{errors.bank_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Bank Contact Email</label>
                                            <Field
                                                name='bank_email'
                                                className={errors.bank_email && touched.bank_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.bank_email}/>
                                            {errors.bank_email && touched.bank_email ?
                                                (<div className='f-field-errors'>{errors.bank_email} </div>) : null
                                            }

                                            <h5 className='profile-data-sub-section'>Credit Reference #1</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='first_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='first_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='first_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='first_creditref_phone'
                                                className={errors.first_creditref_phone && touched.first_creditref_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_phone}/>
                                            {errors.first_creditref_phone && touched.first_creditref_phone ?
                                                (<div className='f-field-errors'>{errors.first_creditref_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='first_creditref_email'
                                                className={errors.first_creditref_email && touched.first_creditref_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_creditref_email}/>
                                            {errors.first_creditref_email && touched.first_creditref_email ?
                                                (<div className='f-field-errors'>{errors.first_creditref_email} </div>) : null
                                            }

                                            <h5 className='profile-data-sub-section'>Credit Reference #2</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='second_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='second_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='second_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='second_creditref_phone'
                                                className={errors.second_creditref_phone && touched.second_creditref_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_phone}/>
                                            {errors.second_creditref_phone && touched.second_creditref_phone ?
                                                (<div className='f-field-errors'>{errors.second_creditref_phone} </div>) : null
                                            }

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='second_creditref_email'
                                                className={errors.second_creditref_email && touched.second_creditref_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.second_creditref_email}/>
                                            {errors.second_creditref_email && touched.second_creditref_email ?
                                                (<div className='f-field-errors'>{errors.second_creditref_email} </div>) : null
                                            }

                                            <h3 className='profile-data-section'>Coverage Information</h3>
                                            <label className='form-f-label'>Coverage Segments*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='coverage_segments'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {segmentOps.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='coverage_segments'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.coverage_segments.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.coverage_segments.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.coverage_segments && touched.coverage_segments ?
                                                        (<div
                                                            className='f-field-errors'>{errors.coverage_segments}</div> ) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Services Offered*</label>

                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='services_offered'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {servicesOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='services_offered'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.services_offered.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.services_offered.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.services_offered && touched.services_offered ?
                                                        (<div
                                                            className='f-field-errors'>{errors.services_offered}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Number of Employees*</label>
                                            <Field
                                                name='number_of_employees'
                                                component='input'
                                                className={errors.number_of_employees && touched.number_of_employees ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Employees*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.number_of_employees}
                                            />
                                            {errors.number_of_employees && touched.number_of_employees ?
                                                (<div
                                                    className='f-field-errors'>{errors.number_of_employees}</div>) : null
                                            }

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='dealer_finder'
                                                    checked={values.dealer_finder}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Add to NOON Finder?</p>
                                            </div>
                                            <br/>
                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='provide_staff_training'
                                                    checked={values.provide_staff_training}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Can NOON provide training of staff?</p>
                                            </div>

                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'> How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='experience_with_noon'
                                                    checked={values.experience_with_noon}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Do you have Experience installing
                                                    NOON?</p>
                                            </div>

                                            <div className="flex--fields--holder">
                                                <div className="flex-field-container">
                                                    <label className="flex-form-label">Customer Service Manager</label>
                                                    <Field name='csm' component='select'
                                                        className='state-selector' placeholder='CSM'>
                                                        <option value="">---</option>
                                                        {this.props.csms.map(csm => (
                                                        <option key={`csm-${csm.id}`}
                                                                value={csm.id}>
                                                            {csm.first_name} {csm.last_name} ({csm.email})
                                                        </option>
                                                        ))}
                                                    </Field>
                                                </div>
                                            </div>

                                            <div className='error-box-cont'>
                                                {this.state.isError === true ?
                                                    <p className='submission-error-text'>Ooops something went wrong!
                                                        Please try again later</p> :
                                                    null
                                                }
                                            </div>

                                            <button className='form-f-button' type="submit">
                                                Save Profile
                                            </button>
                                            {dirty ?
                                                <a className='form-cancel-button'
                                                   onClick={handleReset}>
                                                    Reset Form
                                                </a> :
                                                <a className='form-cancel-button'
                                                   onClick={this.editProfile}>
                                                    Cancel
                                                </a>
                                            }
                                        </Form>
                                    )}
                                </Formik> :
                                <Formik
                                    initialValues={{
                                        role: this.state.userD.role.name,
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        latitude: this.state.companyD.latitude,
                                        longitude: this.state.companyD.longitude,
                                        domain: this.state.companyD.domain,
                                        reseller_certification: this.state.companyD.reseller_certification,
                                        csm: this.state.userD.company.csm && this.state.userD.company.csm.id || "",

                                        years_in_business: this.state.companyD.years_in_business,
                                        coverage_segments: this.state.companyD.coverage_segments.split(','),
                                        services_offered: this.state.companyD.services_offered.split(','),
                                        number_of_employees: this.state.companyD.number_of_employees,

                                        dealer_finder: this.state.companyD.dealer_finder,
                                        where_to_buy: this.state.companyD.where_to_buy,
                                        provide_staff_training: false,
                                        experience_with_noon: this.state.companyD.experience_with_noon,
                                        additional_information_hearAboutNoon: hearAboutNoon,
                                        business_type: this.state.companyD.business_type,
                                        number_of_stores: numberOfStores,

                                        subsidiary_name: subsidiaryName,
                                        mailing_address: mailingAddress,
                                        mailing_city: mailingCity,
                                        mailing_state: this.state.cData.mailing_state,
                                        mailing_postal: mailingPostal,
                                        mailing_country: this.state.cData.mailing_country,
                                        established: this.state.cData.established,
                                        duns: Duns,
                                        sales_name: this.state.cData.sales_name,
                                        sales_phone: this.state.cData.sales_phone,
                                        sales_email: this.state.cData.sales_email,
                                        accounts_name: this.state.cData.accounts_name,
                                        accounts_phone: this.state.cData.accounts_phone,
                                        accounts_email: this.state.cData.accounts_email,
                                        logistics_name: this.state.cData.logistics_name,
                                        logistics_phone: this.state.cData.logistics_phone,
                                        logistics_email: this.state.cData.logistics_email,
                                        bank_name: bankName,
                                        bank_address: bankAddress,
                                        bank_representative: bankRepresentative,
                                        bank_phone: bankPhone,
                                        bank_email: bankEmail,
                                        first_creditref_name: firstCname,
                                        first_creditref_address: firstCaddress,
                                        first_creditref_representative: firstCrepresentative,
                                        first_creditref_phone: firstCphone,
                                        first_creditref_email: firstCemail,
                                        second_creditref_name: secondCaddress,
                                        second_creditref_address: secondCaddress,
                                        second_creditref_representative: secondCrepresentative,
                                        second_creditref_phone: secondCphone,
                                        second_creditref_email: secondCemail,
                                    }}
                                    enableReinitialize={false}
                                    validationSchema={ProfileSchema}
                                    onSubmit={(values, actions) => {
                                        let yearsInB = parseInt(values.years_in_business, 10);
                                        let numberOfE = parseInt(values.number_of_employees, 10);

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }
                                        console.log('about N', hearedAbout);
                                        let cSegments = "";
                                        if (values.coverage_segments != "" && values.coverage_segments != []) {
                                            cSegments = values.coverage_segments.join(",")
                                        }
                                        console.log('s segs', cSegments);

                                        let servicesO = "";
                                        if (values.services_offered != "" && values.services_offered != []) {
                                            servicesO = values.services_offered.join(",")
                                        }
                                        console.log('services', servicesO);

                                        let staffTraining = "";
                                        if(values.provide_staff_training === false) {
                                            staffTraining = "0";
                                        }
                                        if(values.provide_staff_training === true) {
                                            staffTraining = "1";
                                        }


                                        return Promise.all([
                                            request.post(`/api/user/${this.props.id}`)
                                                .send({
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,
                                                }),
                                            request.post(`/api/user/${this.props.companyId}`)
                                                .send({
                                                    name: values.name,
                                                    dba: values.dba,
                                                    primary_jobtitle: values.primary_jobtitle,
                                                    phone: values.phone,
                                                    country: values.country,
                                                    address: values.address,
                                                    city: values.city,
                                                    state: values.state,
                                                    postal: values.postal,
                                                    domain: values.domain,
                                                    reseller_certification: values.reseller_certification,
                                                    years_in_business: yearsInB,
                                                    coverage_segments: cSegments,
                                                    services_offered: servicesO,
                                                    number_of_employees: numberOfE,
                                                    dealer_finder: values.dealer_finder,
                                                    experience_with_noon: values.experience_with_noon,
                                                    provide_staff_training: staffTraining,
                                                    business_type: values.business_type,
                                                    number_of_stores: values.number_of_stores,

                                                    coverage_range: null,

                                                })
                                        ])
                                            .then(data => {
                                                console.log('finished user call');
                                                console.log(data);
                                            })
                                            .then(resp => {
                                                this.setState({updateFlag: true})
                                            })
                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,

                                      }) => (
                                        <Form className='my-f-form'>
                                            <h3>Authorized Reseller Portal Permissions</h3>
                                            <FieldArray
                                                name='role'
                                                render={arrayHelpers => (
                                                    <div className='toggle-radio-gr-table'>
                                                        {roleOptions.map(option => (
                                                            <div key={option.id} className='toggle-radio-gr-container'>
                                                                <input
                                                                    readOnly={true}
                                                                    name='role'
                                                                    type='checkbox'
                                                                    className='toggle--radio--btn'
                                                                    value={option.id}
                                                                    checked={values.role.includes(option.id)}
                                                                />
                                                                <div className='toggle--radio-content'>
                                                                    <div className='toggle--radio--title'>{option.display}</div>
                                                                    <div className='toggle--radio--subtitle'> {option.description} </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                            <h3>Primary Contact Information</h3>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.email}/>

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            disabled={true}
                                                            value={values.first_name}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            disabled={true}
                                                            value={values.last_name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                disabled={true}
                                                value={values.name}
                                            />

                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                disabled={true}
                                                value={values.dba}
                                            />

                                            <label className='form-f-label'>If Subsidiary, Name of Parent Company</label>
                                            <Field
                                                name='subsidiary_name'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Subsidiary Name*'
                                                disabled={true}
                                                value={values.subsidiary_name}
                                            />

                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                disabled={true}
                                                value={values.primary_jobtitle}
                                            />

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                disabled={true}
                                                value={values.phone}
                                            />

                                            <h5 className='profile-data-sub-section'>Company Billing Address</h5>

                                            <label className='form-f-label'>Country*</label>
                                            <Field name='country' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <section className='flex-text-flags-holder'>
                                                <div className ='flags-text'
                                                     style={{
                                                         color: proVerified === true? '#39B54A': '#F7941E',
                                                     }}>
                                                    <span
                                                        className='tb-status-circle'
                                                        style={{
                                                            background: proVerified === true? '#39B54A': '#F7941E',
                                                        }}>

                                                    </span>
                                                    PRO FINDER COORDINATES
                                                </div>
                                                <div className='flags-text'
                                                     style={{
                                                         color: this.state.companyD.address_status === "valid"? '#39B54A': '#F7941E',
                                                     }}>
                                                     <span
                                                         className='tb-status-circle'
                                                         style={{
                                                             background: this.state.companyD.address_status === "valid"? '#39B54A': '#F7941E',
                                                         }}>
                                                     </span>
                                                    ADDRESS VERIFIED
                                                </div>
                                            </section>

                                            <label className='form-f-label'>Address*</label>
                                            <Field
                                                name='address'
                                                component='input'
                                                className={errors.address && touched.address ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Address*'
                                                disabled={true}
                                                value={values.address}
                                            />

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>City*</label>
                                                    <Field
                                                        name='city'
                                                        component='input'
                                                        className={errors.city && touched.city ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='City*'
                                                        disabled={true}
                                                        value={values.city}
                                                    />
                                                </div>

                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>State*</label>
                                                    <Field name='state' component='select' disabled={true}
                                                           className='state-selector' placeholder='State'>
                                                        {usStateOpts.map(option => (
                                                            <option key={`state-${option.id}`}
                                                                    value={option.id}>
                                                                {option.display}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <Field
                                                        name='postal'
                                                        component='input'
                                                        className={errors.postal && touched.postal ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        disabled={true}
                                                        value={values.postal}
                                                    />
                                                </div>
                                            </div>

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>Latitude*</label>
                                                    <Field
                                                        name='latitude'
                                                        component='input'
                                                        className={errors.latitude && touched.latitude ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Latitude*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.latitude}
                                                    />
                                                    {errors.latitude && touched.latitude ?
                                                        (<div className='f-field-errors'>{errors.latitude}</div>) : null
                                                    }
                                                </div>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>Longitude*</label>
                                                    <Field
                                                        name='longitude'
                                                        component='input'
                                                        className={errors.longitude && touched.longitude ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Longitude*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.longitude}
                                                    />
                                                    {errors.longitude && touched.longitude ?
                                                        (<div className='f-field-errors'>{errors.longitude}</div>) : null
                                                    }
                                                </div>
                                                <div className='flex-field-container last-btn'>
                                                    <section>
                                                        <a className='geo-p-button' onClick={(evt) => this.generateGeopostal(values.latitude, values.longitude, evt)}>Generate Geopostal Data</a>
                                                    </section>
                                                </div>

                                            </div>

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='where_to_buy'
                                                    checked={values.where_to_buy}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Show in Where To Buy Listings?</p>
                                            </div>

                                            <h5 className='profile-data-sub-section'>Company Mailing Address (if different from Billing Address above)</h5>

                                            <label className='form-f-label'>Country</label>
                                            <select
                                                name='mailing_country'
                                                className='single-choice-selector'
                                                value={values.mailing_country}
                                                disabled={true}
                                            >
                                                {countryOpts.map(option => (
                                                    <option key={`mailing_country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>

                                            <label className='form-f-label'>Address</label>
                                            <input
                                                name='mailing_address'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='Address'
                                                value={values.mailing_address}
                                                disabled={true}

                                            />

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>City</label>
                                                    <input
                                                        name='mailing_city'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='City'
                                                        value={values.mailing_city}
                                                        disabled={true}
                                                    />

                                                </div>

                                                {this.state.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            disabled={true}
                                                        >
                                                            {caStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>:
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State</label>
                                                        <select
                                                            name='mailing_state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={values.mailing_state}
                                                            disabled={true}
                                                        >
                                                            {usStateOpts.map(option => (
                                                                <option key={`mailing_state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code</label>
                                                    <input
                                                        name='mailing_postal'
                                                        className='form-f-field'
                                                        type='text'
                                                        placeholder='Postal Code'
                                                        value={values.mailing_postal}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Website*'
                                                disabled={true}
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Year Established*</label>
                                            <Field
                                                name='established'
                                                component='input'
                                                className={errors.established && touched.established ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Year Established*'
                                                value={values.established}
                                                disabled={true}
                                            />
                                            {errors.established && touched.established ?
                                                (<div className='f-field-errors'>{errors.established}</div>) : null
                                            }

                                            <label className='form-f-label'>D&B/DUNS Number</label>
                                            <Field
                                                name='duns'
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                placeholder='D&B/DUNS Number'
                                                disabled={true}
                                                value={values.duns}
                                            />

                                            <label className='form-f-label'>Reseller Certification Number</label>
                                            <Field
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                name='reseller_certification'
                                                placeholder='Reseller Certification Number'
                                                disabled={true}
                                                value={values.reseller_certification}
                                            />

                                            <p className='disclaimer--copy'>Specify your reseller tax number and state
                                                above and upload a copy of your reseller certificate below.
                                                If you sell in multiple states, please upload them as a zip file. If no
                                                reseller certificate is provided, applicable sales tax will be charged
                                                on your purchases.</p>
                                            <br/>
                                            <section>
                                                <a className='edit-p-button' onClick={this.uploadResellerCertificate}>{this.state.uploadingCertificate ? 'Saving...' :  'Upload Certificate'}</a>
                                                <input name="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                                            </section>
                                            <br/>

                                            {this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null"?
                                                <a className='edit-p-button' href={this.state.companyD.reseller_certification_path} target="_blank">View Certificate</a>: null
                                            }

                                            <label className='form-f-label'>Years in Business*</label>
                                            <Field
                                                name='years_in_business'
                                                component='input'
                                                className={errors.years_in_business && touched.years_in_business ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Years in Business*'
                                                disabled={true}
                                                value={values.years_in_business}
                                            />

                                            <label className='form-f-label'>Business Type*</label>
                                            <Field name='business_type' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {businessOpts.map(option => (
                                                    <option key={`business_type-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <label className='form-f-label'>Number of Stores/Branches</label>
                                            <Field
                                                name='number_of_stores'
                                                component='input'
                                                className={errors.number_of_stores && touched.number_of_stores ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Stores/Branches'
                                                disabled={true}
                                                value={values.number_of_stores}
                                            />

                                            <h3 className='profile-data-section'>Contact Information</h3>

                                            <p className='disclaimer--copy'>Please provide appropriate contact information for the departments listed below.
                                                This will ensure we are communicating with the appropriate members of your business. </p>

                                            <h5 className='profile-data-sub-section'>Sales</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='sales_name'
                                                className={errors.sales_name && touched.sales_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                disabled={true}
                                                value={values.sales_name}/>

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='sales_phone'
                                                className={errors.sales_phone && touched.sales_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                disabled={true}
                                                value={values.sales_phone}/>

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='sales_email'
                                                className={errors.sales_email && touched.sales_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.sales_email}/>

                                            <h5 className='profile-data-sub-section'>Accounts Payable</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='accounts_name'
                                                className={errors.accounts_name && touched.accounts_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                disabled={true}
                                                value={values.accounts_name}/>

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='accounts_phone'
                                                className={errors.accounts_phone && touched.accounts_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                disabled={true}
                                                value={values.accounts_phone}/>

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='accounts_email'
                                                className={errors.accounts_email && touched.accounts_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.accounts_email}/>

                                            <h5 className='profile-data-sub-section'>Shipping & Logistics</h5>

                                            <label className='form-f-label'>Name*</label>
                                            <Field
                                                name='logistics_name'
                                                className={errors.logistics_name && touched.logistics_name ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Name*'
                                                disabled={true}
                                                value={values.logistics_name}/>

                                            <label className='form-f-label'>Phone*</label>
                                            <Field
                                                name='logistics_phone'
                                                className={errors.logistics_phone && touched.logistics_phone ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Phone*'
                                                disabled={true}
                                                value={values.logistics_phone}/>

                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='logistics_email'
                                                className={errors.logistics_email && touched.logistics_email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.logistics_email}/>

                                            <h3 className='profile-data-section'>Bank & Credit References</h3>

                                            <p className='disclaimer--copy'>If you would like credit terms to be extended to your business please provide your bank and credit reference(s) for credit review by NOON.
                                                If no credit needs to be extended (i.e., paying by credit card) please leave blank.</p>

                                            <h5 className='profile-data-sub-section'>Bank Reference</h5>

                                            <label className='form-f-label'>Bank Name</label>
                                            <Field
                                                name='bank_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Name'
                                                disabled={true}
                                                value={values.bank_name}/>


                                            <label className='form-f-label'>Bank Address</label>
                                            <Field
                                                name='bank_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Address'
                                                disabled={true}
                                                value={values.bank_address}/>

                                            <label className='form-f-label'>Bank Contact Representative</label>
                                            <Field
                                                name='bank_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Representative'
                                                disabled={true}
                                                value={values.bank_representative}/>

                                            <label className='form-f-label'>Bank Contact Phone Number</label>
                                            <Field
                                                name='bank_phone'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Phone Number'
                                                disabled={true}
                                                value={values.bank_phone}/>

                                            <label className='form-f-label'>Bank Contact Email</label>
                                            <Field
                                                name='bank_email'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Bank Contact Email'
                                                disabled={true}
                                                value={values.bank_email}/>

                                            <h5 className='profile-data-sub-section'>Credit Reference #1</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='first_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                disabled={true}
                                                value={values.first_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='first_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                disabled={true}
                                                value={values.first_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='first_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                disabled={true}
                                                value={values.first_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='first_creditref_phone'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Phone Number'
                                                disabled={true}
                                                value={values.first_creditref_phone}/>

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='first_creditref_email'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                disabled={true}
                                                value={values.first_creditref_email}/>

                                            <h5 className='profile-data-sub-section'>Credit Reference #2</h5>

                                            <label className='form-f-label'>Company Name</label>
                                            <Field
                                                name='second_creditref_name'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Name'
                                                disabled={true}
                                                value={values.second_creditref_name}/>


                                            <label className='form-f-label'>Company Address</label>
                                            <Field
                                                name='second_creditref_address'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Address'
                                                disabled={true}
                                                value={values.second_creditref_address}/>

                                            <label className='form-f-label'>Company Contact Representative</label>

                                            <Field
                                                name='second_creditref_representative'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Representative'
                                                disabled={true}
                                                value={values.second_creditref_representative}/>

                                            <label className='form-f-label'>Company Contact Phone Number</label>
                                            <Field
                                                name='second_creditref_phone'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Phone Number'
                                                disabled={true}
                                                value={values.second_creditref_phone}/>

                                            <label className='form-f-label'>Company Contact Email</label>
                                            <Field
                                                name='second_creditref_email'
                                                className='form-f-field'
                                                component='input'
                                                type='text'
                                                placeholder='Company Contact Email'
                                                disabled={true}
                                                value={values.second_creditref_email}/>

                                            <h3 className='profile-data-section'>Coverage Information</h3>
                                            <label className='form-f-label'>Coverage Segments*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='coverage_segments'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {segmentOps.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='coverage_segments'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.coverage_segments.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.coverage_segments.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Services Offered*</label>

                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='services_offered'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {servicesOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='services_offered'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.services_offered.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.services_offered.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Number of Employees*</label>
                                            <Field
                                                name='number_of_employees'
                                                component='input'
                                                className={errors.number_of_employees && touched.number_of_employees ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Employees*'
                                                disabled={true}
                                                value={values.number_of_employees}
                                            />

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='dealer_finder'
                                                    checked={values.dealer_finder}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Add to NOON Finder?</p>
                                            </div>
                                            <br/>
                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='provide_staff_training'
                                                    checked={values.provide_staff_training}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Can NOON provide training of staff?</p>
                                            </div>

                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'> How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <div className='toggle-switch-gr'>
                                                <input

                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='experience_with_noon'
                                                    checked={values.experience_with_noon}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Do you have Experience installing
                                                    NOON?</p>
                                            </div>

                                            <div className="flex--fields--holder">
                                                <div className="flex-field-container">
                                                    <label className="flex-form-label">Customer Service Manager</label>
                                                    <Field name='csm' component='select' disabled={true}
                                                        className='state-selector' placeholder='CSM'>
                                                        <option value="">---</option>
                                                        {this.props.csms.map(csm => (
                                                        <option key={`csm-${csm.id}`}
                                                                value={csm.id}>
                                                            {csm.first_name} {csm.last_name} ({csm.email})
                                                        </option>
                                                        ))}
                                                    </Field>
                                                </div>
                                            </div>

                                        </Form>
                                    )}
                                </Formik>
                            }

                            <div>
                                <h3 className='location-module'>Locations</h3>
                                <div className="row toolbar">
                                    <button
                                        onClick={this.openNewLocationModal}
                                        className="btn btn-default btn-primary btn-view-users"> New Location
                                    </button>
                                    <span>
                                        <a href="/sample/sampleAddressUpload.csv">Download </a>
                                         sample CSV data
                                    </span>
                                </div>
                                { this.csvUpload() }

                                {this.state.locations.length > 0 ?

                                    <div className='users-table-hoalder'>
                                        <div className='tb-search-holder'>
                                            <div className='search--cont'>
                                                Search: <input
                                                className='tb-search-input'
                                                value={this.state.searchLoc}
                                                onChange={e => this.setState({searchLoc: e.target.value})}
                                            />
                                            </div>
                                            <ReactTable
                                                columns={columns}
                                                data={this.state.locations}
                                                pageSizeOptions={pageOpts}
                                                pageSize={this.state.locations.length}

                                            />
                                        </div>
                                    </div> :
                                    <ReactTable
                                        columns={columns}
                                        pageSizeOptions={pageOpts}
                                        pageSize={this.state.locations.length}
                                    />
                                }

                                {this.newLocationModal()}

                            </div>
                        </div>
                    </div>:
                    <Loader/>
                }
            </div>
        );
    }
}


ViewDidtributorProfile.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/routes/AdminViewUser/ViewDidtributorProfile.js